import { AxiosResponse } from "axios";
import axiosClient from "@/services/api/index";
import {
  LandSubdivisionPackage,
  LandSubdivisionPackagePayload,
} from "@/types/LandSubdivisionPackage";
import { ProjectPageAsset } from "@/services/api/projectPageApi";

export default {
  getByEstateId(
    estateId: string
  ): Promise<AxiosResponse<LandSubdivisionPackage[]>> {
    return axiosClient.get(`land-subdivision-packages/estate/${estateId}`);
  },

  create(
    estateId: string,
    data: LandSubdivisionPackagePayload
  ): Promise<AxiosResponse<LandSubdivisionPackage>> {
    return axiosClient.post(
      `land-subdivision-packages/estate/${estateId}`,
      data
    );
  },

  update(
    id: string,
    data: Partial<LandSubdivisionPackagePayload>
  ): Promise<AxiosResponse<LandSubdivisionPackage>> {
    return axiosClient.patch(`land-subdivision-packages/${id}`, data);
  },

  delete(id: string): Promise<AxiosResponse> {
    return axiosClient.delete(`land-subdivision-packages/${id}`);
  },

  uploadAsset(
    estateId: string,
    assetType: "builder-logo" | "hero-image" | "brochure",
    file: File
  ): Promise<AxiosResponse<ProjectPageAsset>> {
    const fd = new FormData();

    fd.append("file", file);
    return axiosClient.post(
      `land-subdivision-packages/estate/${estateId}/assets/${assetType}`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },
};
